module.exports = new __parcel__URL__("recruitment_zh-tw.d11ff7d9.webp").toString();